// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3ae32ef3] .c-input-container-list-item-label {\n  white-space: normal;\n  padding: 3px 0;\n  line-height: 1.2;\n}\n[data-v-3ae32ef3] .c-input-value_type_select_clearable {\n  max-width: calc(100% - 45px) !important;\n}\n", ""]);
// Exports
module.exports = exports;
